import { bindActionCreators, connect } from '@nextiva/analytics-lib';
import { List } from "../../components";
import { createStructuredSelector } from 'reselect';
import { updateLimitParam, updatePageParam, updateSearchParam } from './state/actions';
import { searchSelector } from './state/selectors';
var mapStateToProps = createStructuredSelector({
  search: searchSelector
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSearchChange: updateSearchParam,
    onLimitChange: updateLimitParam,
    onPageChange: function onPageChange(_a) {
      var selected = _a.selected;
      return updatePageParam(selected);
    }
  }, dispatch);
};

export default connect(List, mapStateToProps, mapDispatchToProps);